// Darstellung von Zeiten, Beträgen und Datumsangaben. Gerechnet wird im
// Backend — hier wird nur formatiert.

export const MONATSNAMEN = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
]

const WOCHENTAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']

// 540 -> "09:00"
export function alsUhrzeit(minuten) {
  const stunden = Math.floor(minuten / 60)
  const rest = minuten % 60
  return `${String(stunden).padStart(2, '0')}:${String(rest).padStart(2, '0')}`
}

// Ist die Uhrzeit vollständig? „14:“ allein genügt nicht.
export function istUhrzeit(wert) {
  return /^([01]\d|2[0-4]):[0-5]\d$/.test(String(wert || ''))
}

/**
 * Vorschlag für den Beginn: die aktuelle Stunde, Minuten bleiben offen.
 *
 * Die Minute weiß nur der Mitarbeiter — sie zu raten hieße, eine falsche
 * Angabe bequem zu machen. Die Stunde dagegen stimmt fast immer, und das
 * Auswahlrad steht damit an der richtigen Stelle statt bei 00.
 */
export function aktuelleStundeOffen() {
  return `${String(new Date().getHours()).padStart(2, '0')}:`
}

// Vorschlag für das Ende: eine Stunde später, Minuten ebenfalls offen.
// Um 23 Uhr wird daraus 24:00 — dort gibt es nur die volle Stunde.
export function stundeSpaeterOffen(wert) {
  const naechste = Math.min(Number(String(wert).split(':')[0] || 0) + 1, 24)
  return naechste === 24 ? '24:00' : `${String(naechste).padStart(2, '0')}:`
}

// 435 -> "7:15 h"
export function alsDauer(minuten) {
  const stunden = Math.floor(minuten / 60)
  const rest = minuten % 60
  return `${stunden}:${String(rest).padStart(2, '0')} h`
}

export function euro(cent) {
  if (cent === null || cent === undefined) return '—'
  return (cent / 100).toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
  })
}

export function kurzesDatum(datum) {
  const [, monat, tag] = datum.split('-')
  return `${tag}.${monat}.`
}

export function wochentag(datum) {
  const [jahr, monat, tag] = datum.split('-').map(Number)
  return WOCHENTAGE[new Date(Date.UTC(jahr, monat - 1, tag)).getUTCDay()]
}

export function istWochenende(datum) {
  const [jahr, monat, tag] = datum.split('-').map(Number)
  const wt = new Date(Date.UTC(jahr, monat - 1, tag)).getUTCDay()
  return wt === 0 || wt === 6
}

// "2026-08-11" für heute, im lokalen Kalender des Geräts.
export function heute() {
  const jetzt = new Date()
  return [
    jetzt.getFullYear(),
    String(jetzt.getMonth() + 1).padStart(2, '0'),
    String(jetzt.getDate()).padStart(2, '0'),
  ].join('-')
}

// Zeitstempel aus SQLite ("2026-08-11 19:04:21", UTC) menschenlesbar machen.
export function zeitpunkt(text) {
  if (!text) return ''
  const datum = new Date(text.replace(' ', 'T') + 'Z')
  if (Number.isNaN(datum.getTime())) return text
  return datum.toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' })
}

export const STATUSTEXT = {
  offen: 'offen',
  eingereicht: 'eingereicht',
  genehmigt: 'genehmigt',
  zurueckgewiesen: 'zurückgewiesen',
}
